import type { PlacedTile, PremiumSquare, WordGrid } from "../../../shared/types";

interface Props {
  width: number;
  height: number;
  tiles: PlacedTile[];
  premiumSquares: PremiumSquare[];
  puzzle?: WordGrid;
  highlight?: string[];
}

export default function ReplayBoard({ width, height, tiles, premiumSquares, puzzle, highlight }: Props) {
  const cellSize = Math.max(16, Math.min(32, Math.floor(320 / Math.max(width, height))));
  const placed = new Map<string, PlacedTile>();
  for (const t of tiles) placed.set(`${t.x},${t.y}`, t);

  const premiumMap = new Map<string, string>();
  for (const p of premiumSquares) premiumMap.set(`${p.x},${p.y}`, p.type);

  const blackSquares = new Set<string>(puzzle?.blackSquares || []);

  return (
    <div
      className="inline-grid gap-px bg-board-border p-1 rounded"
      style={{
        gridTemplateColumns: `repeat(${width}, ${cellSize}px)`,
        gridTemplateRows: `repeat(${height}, ${cellSize}px)`,
      }}
    >
      {Array.from({ length: width * height }, (_, i) => {
        const x = i % width;
        const y = Math.floor(i / width);
        const key = `${x},${y}`;
        const tile = placed.get(key);
        const isBlack = blackSquares.has(key);
        const premium = premiumMap.get(key);
        const isHighlight = highlight?.includes(key);

        if (isBlack) {
          return (
            <div
              key={key}
              className="bg-gray-900 rounded-sm"
              style={{ width: cellSize, height: cellSize }}
            />
          );
        }

        return (
          <div
            key={key}
            className={`relative flex items-center justify-center rounded-sm text-xs font-bold
              ${premium === "DL" ? "bg-blue-200/30" : premium === "TL" ? "bg-blue-400/30" : premium === "DW" ? "bg-pink-200/30" : premium === "TW" ? "bg-red-300/30" : "bg-board-cell"}
              ${isHighlight ? "ring-2 ring-vsw-400" : ""}
            `}
            style={{ width: cellSize, height: cellSize }}
          >
            {tile && (
              <div
                className={`w-full h-full flex items-center justify-center rounded-sm
                  ${tile.fixed ? "bg-gray-500 text-white" : "bg-amber-100 text-gray-900 shadow-sm"}
                `}
              >
                {tile.letter}
              </div>
            )}
            {premium && !tile && (
              <span className="text-[8px] text-vsw-300 opacity-60">{premium}</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
